import FranchiseeApi from './FranchiseeApi';

export function changeFranchisee(frachise) {
  return FranchiseeApi.create_session(frachise.id).then((response) => {
    window.location.href = `${location.origin}/pro`;
  });
}
